BaseModel                 = require('base/model')
TwilioCallbacksCollection = require('./twilio-callbacks/collection')

config = require('../../../../src/config').default

class CallInspectorModel extends BaseModel

  urlRoot: 'calls'

  parse: (response) ->
    attrs = _.clone(response)
    attrs.alerts = _.filter(response.events, (e) => e.type == 'QualityWarning' || e.type == 'QualityWarningCleared')
    attrs.events = _.filter(response.events, (e) => e.type != 'QualityWarning' && e.type != 'QualityWarningCleared')
    @parseAlertName(attrs.alerts)
    @injectPapertrailUrl(attrs)
    @injectPlayerUrls(attrs)
    @twilioCallbacks = new TwilioCallbacksCollection(response.call.callbacks)
    delete response.call.callbacks
    attrs

  parseAlertName: (alerts) ->
    _.each(alerts, (alert) ->
      data = JSON.parse(alert.data)
      cleared = if alert.type == 'QualityWarningCleared' then ' (Cleared)' else ''
      if data
        switch data.type
          when 'high-rtt'
            alert.name = 'High RTT'
          when 'low-mos'
            alert.name = 'Low Mos'
          when 'high-jitter'
            alert.name = 'High Jitter'
          when 'high-packet-loss'
            alert.name = 'High Packet Loss'
          when 'constant-audio-output-level'
            alert.name = 'No Audio Output Detected'
          when 'constant-audio-input-level'
            alert.name = 'No Audio Detected'
          when 'speaker-devices-set-failed'
            alert.name = 'Active Speaker Not Supported'

        alert.name = alert.name + cleared if alert.name
    )

  injectPapertrailUrl: (attrs) ->
    call = attrs.call
    url = "https://papertrailapp.com/events?q=#{call.callKey}+OR+#{call.callSid}"

    if call.ownerId
      url += escape('+OR+"userId=' + call.ownerId + ']"')

    if call.startTime
      timestamp = Math.floor(call.startTime / 1000)
      url += "&time=#{timestamp}"

    attrs.papertrailUrl = url

  injectPlayerUrls: (attrs) ->
    call = attrs.call
    baseUrl = "#{config.caiDomain}/conversations"
    rec.playerUrl = "#{baseUrl}/#{call.callKey}" for rec in call.recordings

    if call.voicemail
      call.voicemail.playerUrl = "#{baseUrl}/#{call.callKey}"

module.exports = CallInspectorModel
